import { defineInputRule } from "prosekit/extensions/input-rule";
import { InputRule } from "prosekit/pm/inputrules";

// Regex pattern for markdown images: ![alt](url)
const MARKDOWN_IMAGE_PATTERN = /!\[([^\]]*)\]\(([^)]+)\)$/;
const SAFE_URL = /^(https?|ftps?):\/\//;

/**
 * Apply image nodes when a markdown image is typed.
 * Example: ![alt text](https://example.com/image.gif) -> converts to an image on typing the closing parenthesis
 */
export function defineMarkdownImageInputRule() {
  return defineInputRule(
    new InputRule(MARKDOWN_IMAGE_PATTERN, (state, match, from) => {
      const [fullMatch, alt, src] = match;
      if (!src || !SAFE_URL.test(src.trim())) return null;

      // Create an image node with the URL
      const node = state.schema.nodes.image.create({
        src: src.trim(),
        alt: alt || "",
      });

      // Replace the markdown syntax with the image node
      return state.tr.replaceWith(from, from + fullMatch.length, node);
    }),
  );
}
